import ApiService from '../apiservice'

export default class MotivoResultadoService extends ApiService {
  constructor() {
    super('/motivoResultado');
  }

  cadastrar(motivo) {
    return this.post('/',motivo);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterar(motivo) {
    return this.put(`/${motivo.codigo}`,motivo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}
